/**
 * Safely send custom events to heap using the global heap object.
 * See https://developers.heap.io/reference/track
 *
 * @example heapTrack('Closed Modal', {modalType: 'Price Details'});
 */
export function heapTrack(eventName, eventProperties) {
  if (window?.heap?.track && typeof window.heap.track === 'function') {
    window.heap.track(eventName, eventProperties);
  }
}
